import type { FileMapDataSubcategory, FileMapDataSubcategoryStyleLegend } from '../types'
import { layers_radinfra_traffic_signs } from './layers/radinfra_traffic_signs'
import { withBikelaneVisualLineOffset } from './layers/utils/bikelaneLineOffset'
import { wrapSourceLayers } from './layers/utils/wrapSourceLayers'

const subcatId = 'bikelanes'
const source = 'atlas_bikelanes'
const sourceLayer = 'bikelanes'
const bikelanesTrafficSignLegend: FileMapDataSubcategoryStyleLegend[] = [
  {
    id: 'present',
    name: 'Beschildert',
    style: {
      type: 'line',
      color: '#a1e217',
    },
  },
  {
    id: 'none',
    name: 'Unbeschildert (explizit)',
    style: {
      type: 'line',
      color: '#00c29e',
    },
  },
  {
    id: 'missing',
    name: 'Angaben fehlen',
    style: {
      type: 'line',
      color: '#fda5e4',
    },
  },
  {
    id: 'zoom_needed',
    name: 'Auf dieser Zoomstufe können die Daten nicht angezeigt werden',
    style: {
      type: 'line',
      color: 'gray',
    },
  },
]

export const subcat_radinfra_trafficSigns: FileMapDataSubcategory = {
  id: subcatId,
  name: 'Beschilderung',
  ui: 'checkbox',
  beforeId: 'atlas-app-beforeid-top',
  sourceId: source,
  styles: [
    {
      id: 'default',
      name: 'Beschilderung', // field hidden
      layers: wrapSourceLayers({
        layers: withBikelaneVisualLineOffset(layers_radinfra_traffic_signs),
        source,
        sourceLayer,
      }),
      legends: bikelanesTrafficSignLegend,
    },
  ],
}
